import { call, select, takeEvery } from "redux-saga/effects";
import { logout } from "../actions/actions";
import Auth0 from "auth0-js";
import logoutfunc from "./logout";
import authenticate from "./authenticate";

const getLocation = (state) => state.router.location;

export default function* authenticationFlow() {
  const REACT_APP_AUTH0_DOMAIN =
    window.process !== undefined ? window.process.env.REACT_APP_AUTH0_DOMAIN : process.env.REACT_APP_AUTH0_DOMAIN;
  const REACT_APP_AUTH0_AUDIENCE =
    window.process !== undefined ? window.process.env.REACT_APP_AUTH0_AUDIENCE : process.env.REACT_APP_AUTH0_AUDIENCE;
  const REACT_APP_AGENTCLIENTID =
    window.process !== undefined ? window.process.env.REACT_APP_AGENTCLIENTID : process.env.REACT_APP_AGENTCLIENTID;
  const location = yield select(getLocation);
  // Componente que invoca a la ventana de login principal (auth0)
  const auth0 = new Auth0.WebAuth({
    domain: REACT_APP_AUTH0_DOMAIN,
    clientID: REACT_APP_AGENTCLIENTID,
    audience: REACT_APP_AUTH0_AUDIENCE,
    redirectUri: `${window.location.origin}/authenticated?sourceURL=${btoa(
      location.pathname + location.search + location.hash
    )}`,
    responseType: "token id_token",
    scope: "openid profile email",
  });

  yield call(authenticate, auth0, location);
  yield takeEvery(logout, logoutfunc, auth0);
}
